import { render, staticRenderFns } from "./KnProductSubcategories.vue?vue&type=template&id=4bcfbf72&"
import script from "./KnProductSubcategories.vue?vue&type=script&lang=js&"
export * from "./KnProductSubcategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports